// Runtime polyfills for older browsers / mobile webviews.
// Fixes "Uncaught TypeError: ....at is not a function" crashes reported in production
// (Array/String.prototype.at is ES2022 and unsupported on older Safari/Chrome/WebView).
(function () {
  function at(n) {
    n = Math.trunc(n) || 0;
    if (n < 0) n += this.length;
    if (n < 0 || n >= this.length) return undefined;
    return this[n];
  }
  function define(proto) {
    if (proto && typeof proto.at !== 'function') {
      Object.defineProperty(proto, 'at', { value: at, writable: true, configurable: true });
    }
  }
  define(Array.prototype);
  define(String.prototype);
  try { define(Object.getPrototypeOf(Int8Array.prototype)); } catch (e) { /* TypedArray base not available */ }
})();
